import { ZodiosHooks } from '@zodios/react';
import { createApiClient } from '../codegen/address-api';

export { schemas as addressSchemas } from '../codegen/address-api';

// Fallback host is localhost, a "potentially trustworthy" origin (Secure
// Contexts spec), so https pages can issue requests to it without triggering
// Chrome's mixed-content block. This matches the pattern in
// @verifime/api-definition and lets MSW wildcard handlers intercept Storybook
// play tests on https Amplify previews even when the env var is unset.
const ADDRESS_API_HOST = process.env.NEXT_PUBLIC_ADDRESS_API_HOST ?? 'http://localhost:8080';
const ADDRESS_API_KEY = process.env.NEXT_PUBLIC_ADDRESS_API_KEY ?? 'placeholder-api-key';

export const addressApi = createApiClient(ADDRESS_API_HOST);
export const addressHooksApi = new ZodiosHooks('addressApi', addressApi);

addressApi.use({
  name: 'x-api-key',
  request: async (_, config) => ({
    ...config,
    headers: {
      ...config.headers,
      'x-api-key': ADDRESS_API_KEY,
    },
  }),
});
